import { ProductError } from '../../models';

export class ShootThemUpData {
  nbLives: number;
  duration: number;
  pointsGood: number;
  pointsBad: number;
  difficultyUpdates: DifficultyUpdate[];
  pathLottieTargetRight: string;
  pathLottieTargetWrong: string;
  pathLottieLife: string;
  rightTargets: string[];
  fakeTargets: string[];

  constructor(raw?: ShootThemUpData) {
    this.nbLives = raw?.nbLives;
    this.duration = raw?.duration;
    this.pointsGood = raw?.pointsGood;
    this.pointsBad = raw?.pointsBad;
    this.difficultyUpdates = (raw?.difficultyUpdates || []).map(u => new DifficultyUpdate(u));
    this.pathLottieTargetRight = raw?.pathLottieTargetRight;
    this.pathLottieTargetWrong = raw?.pathLottieTargetWrong;
    this.pathLottieLife = raw?.pathLottieLife;
    this.rightTargets = raw?.rightTargets;
    this.fakeTargets = raw?.fakeTargets;
  }

  static validate(): ProductError[] {
    return [];
  }
}

export class DifficultyUpdate {
  startAt: number;
  stayVisible: number;
  speed: number;
  nbTargets: number;

  constructor(raw?: DifficultyUpdate) {
    this.startAt = raw?.startAt;
    this.stayVisible = raw?.stayVisible;
    this.speed = raw?.speed;
    this.nbTargets = raw?.nbTargets;
  }
}

export class ShootThemUpTarget {
  label: string;
  isCorrect: boolean;
  points: number;
}
